import styled from "styled-components"

export const PageTitleWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`
export const SessionTitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 4px 0;

    & > a {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`
export const SessionDurationWrapper = styled.div`
    display: flex;
    flex-direction: row;
`
export const SessionDurationDelimeter = styled.div`
    margin: 0 10px;
    color: ${(props) => props.theme.dateFormatterColor};
`
export const SessionStatusWrapper = styled.div`
    display: flex;
    flex-direction: column;
`
export const SessionStatusDescription = styled.div`
    font-family: ${(props) => props.theme.openSans};
    font-size: 13px;
    color: ${(props) => props.theme.sessionStatusDescriptionColor};
`


export const ScrollerWrapper = styled.div`
    width: 100%;
    position: relative;
    display: flex;
    overflow-x: scroll;

    thead tr {
        height: 50px;
    }

    & > div:first-child { // table wrapper
        width: 630px;
        min-width: 630px;
        position: sticky;
        left: 0;
        border-right: 1px solid ${(props) => props.theme.sessionTableBorderColor};
        z-index: 2;
    }
`
export const TimelineListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: fit-content;
`
export const TimelineListTitle = styled.div`
    height: 51px;
    display: flex;
    background: ${(props) => props.theme.tableRowBackground};
`
export const TimelineListBody = styled.div<{
    timelineWidth: number
}>`
    position: relative;
    width: ${(props) => props.timelineWidth}px;
    background: ${(props) => props.theme.sessionTimelineBackground};
`


export const YearWrapper = styled.div`
    position: relative;
    border-left: 1px solid ${(props) => props.theme.tableRowBorderColor};
`
export const Year = styled.div`
    position: sticky;
    left: 630px;
    height: 25px;
    line-height: 25px;
    width: fit-content;
    padding: 0 8px;
`
export const MonthWrapper = styled.div`
    display: flex;
`
export const Month = styled.div`
    width: 60px;
    height: 25px;
    line-height: 25px;
    padding: 0 8px;
    border-left: 1px solid ${(props) => props.theme.tableRowBorderColor};
`
export const Period = styled.div`
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid ${(props) => props.theme.tableRowBorderColor};

    &:first-child {
        ${YearWrapper}, ${Month}:first-child {
            border-left: none;
        }
    }
`


export const EmptyTimeline = styled.div`
    width: 100%;
    height: 40px;
`
export const TimelineWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 61px;

    &:last-child {
        height: 60px;
    }
`
export const Timeline = styled.div<{
    leftOffset: number
    length: number
    sessionColor: string
}>`
    position: absolute;
    left: ${(props) => props.leftOffset}%;
    width: ${(props) => props.length}%;
    height: 18px;
    border-radius: 9px;
    opacity: 0.8;
    background: ${(props) => props.sessionColor};
    transition: ${(props) => props.theme.defaultTransition};

    &:hover {
        opacity: 1;
    }
`
export const Today = styled.div<{
    leftOffset: number
}>`
    position: absolute;
    opacity: 0.5;
    top: 0;
    bottom: 0;
    width: 2px;
    left: ${(props) => props.leftOffset}%;
    background: ${(props) => props.theme.sessionTodayMarkerColor};
    transition: ${(props) => props.theme.defaultTransition};
    z-index: 1;

    &:hover {
        opacity: 1;
    }
`
export const Tooltip = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    padding: 2px 8px;
    white-space: nowrap;
    font-size: 13px;
    font-family: system-ui;
    line-height: 20px;
    border-radius: 4px;
    background: ${(props) => props.theme.tooltipBackground};
    color: ${(props) => props.theme.tooltipColor};
    opacity: 0;
    transition: opacity 0.1s ease;
    pointer-events: none;
    z-index: 1000;

    &:after {
        content: "";
        display: block;
        position: absolute;
        top: 100%;
        left: calc(50% - 6px);
        border: 6px solid transparent;
        border-top-color: ${(props) => props.theme.tooltipBackground};
        transition: 0.1s ease;
    }
`
